import {
  CloudUploadOutlined,
  CreditCardOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  Button,
  Grid,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import AnimateButton from "../../../Layout/components/@extended/AnimateButton";

const EditCompanyProfile = (props) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          direction={"row"}
          spacing={3}
        >
          <Stack
            direction={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            spacing={1}
          >
            <IconButton
              size="large"
              color="primary"
              onClick={() => props.setEditVendorModal(true)}
            >
              <EditOutlined title="Edit Company" style={{ color: "#01522f" }} />
            </IconButton>
            <Stack direction={"row"} alignItems={"center"}>
              <Typography noWrap variant="h6">
                Company Details
              </Typography>
            </Stack>
          </Stack>

          <Stack
            direction={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            spacing={1}
          >
            <IconButton
              size="large"
              color="primary"
              onClick={props.changeProfilePic}
            >
              <CloudUploadOutlined
                title="Change/upload pic"
                style={{ color: "blue" }}
              />
            </IconButton>
            <Stack direction={"row"} alignItems={"center"}>
              <Typography variant="h6">Profile Picture</Typography>
            </Stack>
          </Stack>

          <Stack
            direction={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            spacing={1}
          >
            {console.log(props.vendorDetails, "ghsigfyisghfyudsgfyugufyg")}
            <IconButton
              size="large"
              color="primary"
              onClick={() => props.setEditBanking(true)}
            >
              <CreditCardOutlined
                title="Edit Banking"
                style={{ color: "#01522f" }}
              />
            </IconButton>
            <Stack direction={"row"} alignItems={"center"}>
              <Typography noWrap variant="h6">
                {props.vendorDetails.bankInfo.bank_account_number === null
                  ? "Add Payout Details"
                  : "Banking Details"}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Grid>

      <Grid item xs={12} marginTop={"1rem"}>
        <AnimateButton>
          <Button
            size="small"
            type="button"
            variant="contained"
            color="primary"
            onClick={() => props.setVendorProfileEditModal(false)}
            sx={{ ml: 1, float: "right" }}
          >
            Done
          </Button>
        </AnimateButton>
      </Grid>
    </Grid>
  );
};

export default EditCompanyProfile;
